import React from 'react';
import { Link } from 'react-router-dom';

// Function to open cookie preferences
const openCookiePreferences = () => {
  localStorage.removeItem('parler_cloud_cookie_consent');
  window.location.reload();
};

export const Footer = () => {
  return (
    <footer className="bg-[var(--bg-secondary)] border-t border-white/10 px-4 md:px-8 lg:px-12 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        {/* Top Section */}
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 md:gap-12 mb-10 md:mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img 
                src="/parler-logo.svg" 
                alt="Parler Cloud" 
                className="h-7 md:h-8 w-auto"
              />
            </Link>
            <p className="text-white/50 text-xs md:text-sm leading-relaxed max-w-[280px]">
              Open, powerful, unified cloud infrastructure built on Triton SmartOS, Edgecast CDN, and Open Compute hardware.
            </p>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white text-xs md:text-sm font-semibold mb-4 uppercase tracking-wider">
              Products
            </h4>
            <div className="flex flex-col gap-2 md:gap-3">
              <Link to="/cloud" className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm">Parler Cloud</Link>
              <Link to="/cdn" className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm">Parler CDN</Link>
              <Link to="/deploy" className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm">Parler Deploy</Link>
              <Link to="/packages" className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm">Pricing</Link>
            </div>
          </div>

          {/* Developers */}
          <div>
            <h4 className="text-white text-xs md:text-sm font-semibold mb-4 uppercase tracking-wider">
              Developers
            </h4>
            <div className="flex flex-col gap-2 md:gap-3">
              <Link to="/docs" className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm">Documentation</Link>
            </div>
          </div>

          {/* Experiences */}
          <div>
            <h4 className="text-white text-xs md:text-sm font-semibold mb-4 uppercase tracking-wider">
              Experiences
            </h4>
            <div className="flex flex-col gap-2 md:gap-3">
              <a href="https://app.parler.com" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm">Parler Social</a>
              <a href="https://play.parler.com" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm">Parler Play</a>
              <a href="https://pay.parler.com" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm">Parler Pay</a>
              <a href="https://shop.parler.com" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm">Parler Shop</a>
              <a href="https://optiocloud.io" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm">Optio</a>
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white text-xs md:text-sm font-semibold mb-4 uppercase tracking-wider">
              Company
            </h4>
            <div className="flex flex-col gap-2 md:gap-3">
              <a href="#" className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm">About Us</a>
              <Link to="/contact" className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm">Contact</Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white text-xs md:text-sm font-semibold mb-4 uppercase tracking-wider">
              Legal
            </h4>
            <div className="flex flex-col gap-2 md:gap-3">
              <Link to="/privacy" className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm">Privacy Policy</Link>
              <Link to="/terms" className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm">Terms of Service</Link>
              <Link to="/do-not-sell" className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm">Do Not Sell My Info</Link>
              <button 
                onClick={openCookiePreferences}
                className="text-white/50 hover:text-[#2a5ff6] transition-colors text-xs md:text-sm text-left"
              >
                Cookie Preferences
              </button>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-white/10 mb-6 md:mb-8" />

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-center items-center gap-4">
          <p className="text-white/50 text-xs md:text-sm text-center">
            © 2026 Parler Technologies. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
